<template>
  <div>
    <!-- Cv Upload section -->
    <div class="second-title">
      <h3>
        Attach Your CV or a Single Document of Your CV &amp; Academic Certificate Here
        <span class="file-size">(max 3MB - .pdf, .doc, .docx)</span>
      </h3>

      <div class="upload-file">
        <div class="fit-object" v-if="!cvName" @click="$refs.myFile.click()">
          <img src="../../assets/images/attachment-logo.svg" alt="attachment icon"/>
          <p>Attach File</p>
          <input type="file" ref="myFile" @change="selectedcvFile" hidden />
        </div>

        <div v-if="cvName">
          <img src="../../assets/images/attachment-logo.svg" alt="attachment icon"/>
          <p>Selected File: {{ cvName }}</p>
          <button @click="resetcvData">Remove File</button>
        </div>
      </div>
      <div v-if="error.selectedCVError">
          <p class="error-text">
            Upload a cv no more than the specified file size and type.
          </p>
          <span v-on:click="clearUploadError('cv')" class="clear-upload-error">
            **Click to continue without uploading a CV file.
          </span>
      </div>
    </div>

    <!-- Video upload section -->
    <div class="second-title">
      <h3>
        Attach Your Video File Here <span class="file-size">(max 100MB - .mp4)</span>
      </h3>

      <div class="upload-file">
        <div
          class="fit-object"
          v-if="!videoName"
          @click="$refs.myVideoFile.click()"
        >
          <img src="../../assets/images/attachment-logo.svg" alt="attachment icon"/>
          <p>Attach File</p>
          <input
            type="file"
            placeholder="Upload CoverImage"
            ref="myVideoFile"
            @change="selectedVideoFile"
            hidden
          />
        </div>

        <div v-if="videoName">
          <img src="../../assets/images/attachment-logo.svg" alt="attachment icon"/>
          <p>Selected File: {{ videoName }}</p>
          <button @click="resetVideoData">Remove File</button>
        </div>
      </div>
      <div v-if="error.selectedVideoError">
          <p class="error-text">
            Upload a video no more than the specified file size and type.
          </p>
          <span v-on:click="clearUploadError('video')" class="clear-upload-error">
            **Click to continue without uploading a video file.
          </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ApplicantCvVideo',
  data() {
    return {
      formData: {
        selectedCV: null,
        selectedVideo: null,
      },
      error: {
        selectedVideoError: false,
        selectedCVError: false
      },
      videoName: null,
      cvName: null,
      cvUploadError:
      'We accept only pdf, doc, docx files of not more than 3MB.',
      videoUploadError:
      'We accept only mp4 videos of not more than 100MB.',
    };
  },
  methods: {
    selectedcvFile(event) {
      if ((event.target.files && event.target.files[0].type === 'application/pdf' ||
        event &&
        event.target.files[0].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
         event.target.files[0].size <= 3000000
      ) {
        this.formData.selectedCV = event.target.files[0];
        this.$emit('selectedFile', {name: 'cv', value: this.formData.selectedCV});
        this.cvName = event.target.files[0].name;
        this.error.selectedCVError = false;

        // send cv validation status to parent profileSettings component
        this.$emit('selectedCVError', false);
      } else {
        this.error.selectedCVError = true;

        // send cv validation status to parent profileSettings component
        this.$emit('selectedCVError', true);
        this.$toastr.error(this.cvUploadError, 'Wrong File Type/Size:');
      }
    },
    selectedVideoFile(event) {
      if (
        event.target.files &&
        event.target.files[0].type === 'video/mp4' &&
        event.target.files[0].size <= 100000000
      ) {
        this.formData.selectedVideo = event.target.files[0];
        this.$emit('selectedFile', {name: 'video', value: this.formData.selectedVideo});
        this.videoName = event.target.files[0].name;
        this.error.selectedVideoError = false;

        // send video validation status to parent profileSettings component
        this.$emit('selectedVideoError', false);
      } else {
        this.error.selectedVideoError = true;

        // send video validation status to parent profileSettings component
        this.$emit('selectedVideoError', true);
        this.$toastr.error(this.videoUploadError, 'Wrong File Type/Size:');
      }
    },
    resetVideoData() {
      this.videoName = null;
      this.formData.selectedVideo = null;
      this.$emit('selectedFile',
        {
          name: 'video',
          value: this.formData.selectedVideo
        }
      );
    },
    resetcvData() {
      this.cvName = null;
      this.formData.selectedCV = null;
      this.$emit('selectedFile',
        {
          name: 'cv',
          value: this.formData.selectedCV
        }
      );
    },
    clearUploadError (file) {
      if(file === 'cv') {
        this.error.selectedCVError = false;

        // send cv validation status to parent profileSettings component
        this.$emit('selectedCVError', false);

      } else if (file === 'video') {
        this.error.selectedVideoError = false;

        // send video validation status to parent profileSettings component
        this.$emit('selectedVideoError', false);
      }
    },
  },
};
</script>
<style scoped>
.second-title {
  margin-bottom: 50px;
}
.second-title h3 {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.628rem;
  color: var(--colorSecondary);
  margin-bottom: 13px;
}
.upload-file {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background: var(--white);
  border: 1px dashed #DBDBDB;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 20px;
  cursor: pointer;
  height: 150px;
  max-height: 150px;
}
.fit-object {
  width: 100%;
}
.upload-file p {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #606060;
  margin-top: 16px;
}
.file-size {
  font-size: 12px;
}
.error-text {
  color: tomato;
  margin-top: 12px;
}
.clear-upload-error {
  cursor: pointer;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  margin-top: 10px;
}
</style>
